import { render, staticRenderFns } from "./GasFee.vue?vue&type=template&id=3f29d0fb&"
import script from "./GasFee.vue?vue&type=script&lang=js&"
export * from "./GasFee.vue?vue&type=script&lang=js&"
import style0 from "./GasFee.vue?vue&type=style&index=0&id=3f29d0fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports